import FlatsListItem from './FlatsListItem';

export default FlatsListItem;



// WEBPACK FOOTER //
// ./src/components/FlatsList/FlatsListItem/index.js